<script setup lang="ts">
import BackstageButton from '@/components/common/BackstageButton.vue';
import { ButtonVariant } from '@/models/button-variant.enum';
import { useI18n } from 'vue-i18n';
import ModalContainer from './ModalContainer.vue';
import ModalHeader from './ModalHeader.vue';

const emit = defineEmits<{
  close: [];
  continue: [];
}>();

const { t } = useI18n();
</script>

<template>
  <ModalContainer @close="emit('close')">
    <template #header>
      <ModalHeader
        :title="t('excel_order_upload.overwrite_warning_modal.title')"
        :description="t('excel_order_upload.overwrite_warning_modal.description')" />
    </template>
    <template #footer>
      <BackstageButton :variant="ButtonVariant.SECONDARY" :full-width="true" @click="emit('close')">{{
        t('excel_order_upload.overwrite_warning_modal.button_label.cancel')
      }}</BackstageButton>
      <BackstageButton :variant="ButtonVariant.PRIMARY" :full-width="true" @click="emit('continue')">{{
        t('excel_order_upload.overwrite_warning_modal.button_label.continue')
      }}</BackstageButton>
    </template>
  </ModalContainer>
</template>
